module.exports = __webpack_public_path__ + "img/tram-gray.caa72fc5.svg";